import React, { useEffect, useState } from "react"
import useLoader from "../../../../shared/components/loading-dialog/useLoader.hook";
import useReportingAndAnalyticsApi from "../../../pages/reporting-and-analytics/useReportingAndAnalyticsApi";
import LoadingDialogComponent from "../../../../shared/components/loading-dialog/loading-dialog.component";
import useWizardReportDataContext from "../contexts/useWizardReportData.context";


/**
 * @author Pradeep R <pradeep.rajendran@rldatix.com>
 * @createdOn Dec/01/2024
 */
export function useGetReportDetailsApi(reportCode: string | undefined | null) {

    const { getWizardReportDetails } = useReportingAndAnalyticsApi();
    const { initializeReportData } = useWizardReportDataContext();

    useEffect(() => {

        if (!reportCode) { // for new
            initializeReportData(null);
        } else { // for edit
            reportDetailsLoader.loadAsync();
        }

    }, [reportCode])

    const reportDetailsLoader = useLoader({
        loaderName: "Report Details",
        loadAsync: () =>
            getWizardReportDetails(reportCode!,
                {
                    doIf: () => reportDetailsLoader.isNotLoading,
                    doBefore: () => {
                        initializeReportData(null);
                        reportDetailsLoader.SET_LOADING("Loading Report Details...");
                    },
                    onFulfilled: (data) => {
                        initializeReportData(data)
                        reportDetailsLoader.SET_SUCCESS("Success.!");
                    },
                    onException: reportDetailsLoader.SET_EXCEPTION,
                }
            ),
    });


    const ReportDetailsLoadingIndicator = () => {
        return <LoadingDialogComponent loaderHook={reportDetailsLoader} />
    }

    // ---
    return {
        ReportDetailsLoadingIndicator,
        reportDetailsLoader,
    }
}